import styled from 'styled-components';

export default styled.span`
  color: #767676;
  margin: 0 0.5rem;

  &:after {
    content: '•';
  }
`;
